import React from 'react'
import './Home.css'
import Banner from '../../components/Banner/Banner'
import Products from '../../components/Products/Products'


const Home = () => {
  return (
    <div>
      <Banner/>
      <Products/>
    </div>
  )
}

export default Home